export default "__VITE_ASSET__dt_c9FoP__"